// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"styles_buttonsContainer__ULUXr","qr-code":"styles_qr-code__56pKW"};